import React, { useState, useEffect, useRef } from 'react';
import { toastr } from 'react-redux-toastr';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import moment from 'moment';
import $ from "jquery";
import { endOfDay } from "date-fns";

import ManageAssetsContainer from '../../smart/menuComponentsContainer/ManageAssetsContainer';
import AddAssetContainer from '../../smart/menuComponentsContainer/AddAssetContainer';
import DateDropdown from '../../dump/menuComponents/DateDropdown';
import SearchBar from './SearchBar';
import ModalSavePreset from '../../smart/modals/ModalSavePreset';
import ModalDeletePreset from '../../smart/modals/ModalDeletePreset';
import CustomButton from '../../CustomButton';
import { CustomButtonToggle } from '../../DropdownComponents';
import { columnSelectIcon } from '../../helpers/iconHelpers';
import { isCustomUserPermissions } from '../../helpers/helperUsers';
import { detectDeviceStatus } from '../../helpers/helperVehicle';

import './menuComponents.sass'
import './Reports.sass'
import './manageVehicles.sass'
import { getDevicesListSearch, getPartnerCompanies } from "../../../action/CompaniesActions";
import { deleteUserCustomPresets, getUserCustomPresets, saveUserCustomPresets } from "../../../action/ClientActions";

const ManageAssets = (props) => {
	const { user, company, selectedCompanies, toggleLoader, setSelectedCompanies } = props
	const userRole = user.roles[0]
	const userPermissions = user.permissions || []
	const hasAccessAddVehicle = userRole === 'partner' || isCustomUserPermissions(userRole, userPermissions, 'vehicle_add')

	const [searchText, setSearchText] = useState('');
	const [searchCompaniesTerm, setSearchCompaniesTerm] = useState('');
	const [searchData, setSearchData] = useState([]);
	const [devices, setDevices] = useState([]);
	const [devicesInit, setDevicesInit] = useState([]);
	const [companyData, setCompanyData] = useState([]);
	const [highlightData, setHighlightData] = useState(false);
	const [columns, setColumns] = useState({
		...{
			'Activated Date': false,
			'Company': true,
			'Current Driver': false,
			'Channel Status': true,
			'Data Usage': true,
			'Device ID': true,
			'Group': true,
			'ICCID': false,
			'IMEI': false,
			'Install Report': false,
			'Activity Status': true,
			'Settings Profile': true,
			'License Plate': false,
			'VIN': false
		}, ...JSON.parse(localStorage.getItem('vehicleColumns'))
	});
	const [selectedDevices, setSelectedDevices] = useState([]);

	const [sortDevicesName, setSortDevicesName] = useState('vehicle_name');
	const [sortDevicesOrder, setSortDevicesOrder] = useState('asc');

	const [startDate, setStartDate] = useState(moment().clone().startOf('week').format('YYYYMMDD'));
	const [endDate, setEndDate] = useState(moment().format('YYYYMMDD'));
	const [companiesList, setCompaniesList] = useState([])
	const [companiesListInit, setCompaniesListInit] = useState([])
	const [showCompanies, setShowCompanies] = useState(false);
	const [showPresets, setShowPresets] = useState(false);
	const [customPresetsList, setCustomPresetsList] = useState([]);
	const [deleteCustomPreset, setDeleteCustomPreset] = useState('');
	const [showCustomPsesetSaveModal, setShowCustomPsesetSaveModal] = useState(false);
	const [showCustomPsesetDeleteModal, setShowCustomPsesetDeleteModal] = useState(false);
	const [upd, setUpd] = useState(false);

	const [page, setPage] = useState(1)
	const [sizePerPage, setSizePerPage] = useState(20)
	const [totalSize, setTotalSize] = useState(0)

	const presetsList = [
		{ name: 'Modem Info', fields: ['device_id', 'company_name', 'group_name', 'imei', 'iccid'] },
		{ name: 'Data Usage', fields: ['device_id', 'company_name', 'group_name', 'data_usage'] },
		{ name: 'Profiles', fields: ['device_id', 'company_name', 'group_name', 'profile'] }
	];

	useEffect(() => {
		setSearchText('')
		getCompanies()
	}, [company.company_id])

	useEffect(() => {
		getDevices()
	}, [selectedCompanies, companiesListInit])

	useEffect(() => {
		if (devices.length) {
			getDevices()
		}
	}, [sortDevicesName, sortDevicesOrder])

	const getCompanies = () => {
		if (!company || (!company.name || !company.company_id)) {
			return
		}

		toggleLoader(true)
		getPartnerCompanies()
			.then(async (res) => {
				const companyData = _.orderBy(await res.data.response.companies, ['company_name']);
				companyData.map((elm, index) => {
					elm.id = elm.id.toString();
					if (index === 0) {
						elm.checked = true;
					} else {
						elm.checked = false;
					}
				});

				setCompanyData(companyData)
				setCompaniesList(companyData)
				setCompaniesListInit(companyData)
				toggleLoader(false)
			})
			.catch(error => {
				toggleLoader(false)
				toastr.error('There was an issue getting your available companies. Please try again later.')
			})
	}

	const buildDeviceListParams = (argSearchText, du_start_ts, du_end_ts, pagination) => {
		const includeDataMap = {
			'Data Usage': 'data_usage',
			'ICCID': 'modem',
			'Current Driver': 'driver'
		};

		const includeData = Object.entries(includeDataMap)
			.filter(([key]) => columns[key])
			.map(([, value]) => value);

		let params = {
			company_ids: selectedCompanies,
			...pagination,
			order_fields: sortDevicesName,
			order_dir: sortDevicesOrder,
			du_start_ts,
			du_end_ts,
			...(includeData.length && {
				include_data: includeData.join(',')
			}),
		}
		if (argSearchText) {
			params = {
				...params,
				search_condition: 'or',
				search_fields: 'vehicle_name,device_id,serial_number',
				search_str: argSearchText + ',' + argSearchText + ',' + argSearchText,
			}
		}
		return params
	}

	const processDeviceRows = (rawDevices) => rawDevices.map((item) => {
		item.simcard_iccid = item?.modem?.simcard_iccid || ''
		item.status = detectDeviceStatus(item)
		item.company_name = companiesListInit.find(({ id }) => id === item.company_id).company_name || 'N/A';

		return item
	})

	const getDevices = (
		argPage = page,
		argSizePerPage = sizePerPage,
		argSearchText = searchText,
		du_start_ts = moment(startDate).format('YYYYMMDD000000'),
		du_end_ts = moment(endDate).format('YYYYMMDD000000')
	) => {
		if ((!selectedCompanies.length || !companiesListInit.length) && !argSearchText) {
			setDevicesInit([])
			setDevices([])
			return
		}

		toggleLoader(true);
		const params = buildDeviceListParams(argSearchText, du_start_ts, du_end_ts, { page_number: argPage, page_size: argSizePerPage })
		getDevicesListSearch(params)
			.then(res => {
				const { devices, total_number } = res.data.response
				const initDevices = processDeviceRows(devices)

				setDevicesInit(initDevices)
				setDevices(_.clone(initDevices))
				setTotalSize(total_number || 0)
				setPage(argPage || page)
				setSizePerPage(argSizePerPage || sizePerPage)

				toggleLoader(false)
			})
			.catch(error => {
				toggleLoader(false)
				toastr.error('There was an issue getting your available vehicles. Please try again later.')
			})
	}

	const exportCacheRef = useRef({ key: null, data: null })

	const getAllDevicesForExport = async () => {
		if ((!selectedCompanies.length || !companiesListInit.length) && !searchText) {
			return []
		}

		const du_start_ts = moment(startDate).format('YYYYMMDD000000')
		const du_end_ts = moment(endDate).format('YYYYMMDD000000')
		const params = buildDeviceListParams(searchText, du_start_ts, du_end_ts)
		const cacheKey = JSON.stringify(params)

		const cache = exportCacheRef.current
		if (cache.data && cache.key === cacheKey) {
			return cache.data
		}

		toggleLoader(true);
		try {
			const res = await getDevicesListSearch(params)
			const data = processDeviceRows(res.data.response.devices)
			exportCacheRef.current = { key: cacheKey, data }
			return data
		}
		finally {
			toggleLoader(false)
		}
	}

	const handlePageChange = (argPage, argSizePerPage) => {
		getDevices(argPage, argSizePerPage)
	}

	const handleSizePerPageChange = (argSizePerPage) => {
		getDevices(page, argSizePerPage)
	}

	const dataSearch = (e) => {
		const value = e ? e.target.value : searchText;

		setSearchText(value)
		setTimeout(() => getDevices(page, sizePerPage, e.target.value.trim()), 500)
	}

	const onSearchCompanies = (e) => {
		const value = e ? e.target.value.toLowerCase() : searchCompaniesTerm
		const filter = companiesListInit.filter(item => item.company_name.toLowerCase().includes(value))

		setCompaniesList(filter)
		setSearchCompaniesTerm(value)
	}

	const onClearAllClick = () => {
		setSelectedCompanies([])
		setDevices([])
	}

	const toggleCheckbox = ({ target }) => {
		const { name, checked, id } = target

		if (name) {
			if (checked) {
				setSelectedCompanies([...new Set([...selectedCompanies, id])])
			}
			else {
				setSelectedCompanies(_.difference(selectedCompanies, [id]))
			}
			setUpd(!upd);
		} else {
			ReactGA.event({
				category: userRole,
				action: 'Select Column',
				label: (checked ? 'Add ' : 'Remove ') + id
			})
			const updatedColumns = { ...columns, ...{ [formatColumnsToGet(id)]: checked } }
			setColumns(updatedColumns);
			localStorage.setItem('vehicleColumns', JSON.stringify(updatedColumns));
		}
	}

	const formatColumnsToGet = (columnName) => {
		let name;
		switch (columnName) {
			case 'activated_timestamp':
				name = 'Activated Date';
				break;
			case 'company_name':
				name = 'Company';
				break;
			case 'driver':
				name = 'Current Driver';
				break;
			case 'channel_status':
				name = 'Channel Status';
				break;
			case 'data_usage':
				name = 'Data Usage';
				break;
			case 'device_id':
				name = 'Device ID';
				break;
			case 'group_name':
				name = 'Group';
				break;
			case 'iccid':
				name = 'ICCID';
				break;
			case 'imei':
				name = 'IMEI';
				break;
			case 'install_report':
				name = 'Install Report';
				break;
			case 'online':
				name = 'Online Status';
				break;
			case 'profile':
				name = 'Settings Profile';
				break;
			case 'tag_plate':
				name = 'License Plate';
				break;
			case 'vin_number':
				name = 'VIN';
				break;
			default:
				name = columnName;
				break;
		}

		return name;
	}

	const formatColumnsToSet = (columnName) => {
		let name;
		switch (columnName) {
			case 'Activated Date':
				name = 'activated_timestamp';
				break;
			case 'Company':
				name = 'company_name';
				break;
			case 'Current Driver':
				name = 'driver';
				break;
			case 'Channel Status':
				name = 'channel_status';
				break;
			case 'Data Usage':
				name = 'data_usage';
				break;
			case 'Device ID':
				name = 'device_id';
				break;
			case 'Group':
				name = 'group_name';
				break;
			case 'ICCID':
				name = 'iccid';
				break;
			case 'IMEI':
				name = 'imei';
				break;
			case 'Install Report':
				name = 'install_report';
				break;
			case 'Activity Status':
				name = 'online';
				break;
			case 'Settings Profile':
				name = 'profile';
				break;
			case 'License Plate':
				name = 'tag_plate';
				break;
			case 'VIN':
				name = 'vin_number';
				break;
			default:
				name = columnName;
				break;
		}

		return name;
	}

	const selectDevice = (row) => {
		ReactGA.event({
			category: userRole,
			action: 'Toggle Devices',
			label: 'Select One Device'
		})

		selectedDevices.includes(row.device_id) ?
			setSelectedDevices(selectedDevices.filter((id) => id !== row.device_id)) :
			setSelectedDevices([...selectedDevices, row.device_id])
	}

	const filterColumn = (e, column, value) => {
		let newDevices = [];
		if (column === 'clear_all') {
			// FWSD-5030
			if (!devices.length) {
				setDevices(devicesInit);
			}
			else {
				setDevices([]);
			}
			ReactGA.event({
				category: userRole,
				action: 'Filter Column',
				label: 'Clear All'
			})
			return
		}

		if (!e.target.checked) {
			if (column === 'latest_hdderror') {
				value === 'Needs Reformat'
					? newDevices = devices.filter(e => _.isEmpty(e.latest_hdderror) || e.latest_hdderror.count === 0)
					: newDevices = devices.filter(e => !_.isEmpty(e.latest_hdderror) && e.latest_hdderror.count > 0)
			}
			else if (column === 'group_name') {
				newDevices = devices.filter(e => value === 'No group' ? (e.group_name && e.group_name.length) : e.group_name !== value);
			}
			else {
				newDevices = devices.filter(e => e[column] !== value);
			}
			e.target.checked = true;
		}
		else {
			if (column === 'latest_hdderror') {
				newDevices = [...devices];
				value === 'Needs Reformat' ?
					newDevices.unshift(...devicesInit.filter(e => !_.isEmpty(e.latest_hdderror) && e.latest_hdderror.count > 0)) :
					newDevices.unshift(...devicesInit.filter(e => _.isEmpty(e.latest_hdderror) || e.latest_hdderror.count === 0))
			}
			else if (column === 'group_name') {
				newDevices = [...devicesInit.filter(e => value === 'No group' ? (!e.group_name || !e.group_name.length) : e.group_name === value), ...devices];
			}
			else {
				newDevices = [...devicesInit.filter(e => e[column] === value), ...devices];
			}
			e.target.checked = false;
		}

		ReactGA.event({
			category: userRole,
			action: 'Filter Column',
			label: column + ': ' + value
		})
		setDevices(newDevices)
	}

	const filterConfigColumn = (e, value) => {
		let newDevices = [];
		if (!e.target.checked) {
			if (value !== 'Manual' && value !== 'Pending') {
				newDevices = devices.filter(e => e['uploaded_company_profile'] !== value);
			}
			else if (value === 'Pending') {
				newDevices = devices.filter(e => e['config_checksum'] !== 1)
			}
			else {
				newDevices = devices.filter(e => (e['config_checksum'] === 1 || (e['uploaded_company_profile'] !== 'Manual' && e['uploaded_company_profile'])))
			}
		}
		else {
			if (value !== 'Manual' && value !== 'Pending') {
				newDevices = [...devicesInit.filter(e => e['uploaded_company_profile'] === value), ...devices];
			}
			else if (value === 'Pending') {
				newDevices = [...devicesInit.filter(e => e['config_checksum'] === 1), ...devices];
			}
			else {
				newDevices = [...devicesInit.filter(e => (e['config_checksum'] !== 1 && (e['uploaded_company_profile'] === 'Manual' || !e['uploaded_company_profile']))), ...devices];
			}
		}
		setDevices(newDevices)
	}

	const handleDevicesSortChange = (sortName, sortOrder) => {
		setSortDevicesName(sortName)
		setSortDevicesOrder(sortOrder)
	}

	const changeDate = async (selectedStartDate, selectedEndDate) => {
		toggleLoader(true);
		const newStartDate = selectedStartDate ? moment(selectedStartDate).format('YYYYMMDD') : moment(startDate).format('YYYYMMDD');
		const newEndDate = selectedEndDate ? moment(selectedEndDate).format('YYYYMMDD') : moment(endDate).format('YYYYMMDD');
		setStartDate(newStartDate)
		setEndDate(newEndDate)
        getDevices(
			page,
			sizePerPage,
			searchText,
			moment(newStartDate).format('YYYYMMDD000000'),
			moment(newEndDate).format('YYYYMMDD000000'),
		);
	}

	const toggleChangePresets = (data) => {
		let psesetsList = {};

		Object.keys(columns).map((name) => {
			name = formatColumnsToSet(name);
			ReactGA.event({
				category: userRole,
				action: 'Select Column',
				label: (data.includes(name) ? 'Add ' : 'Remove ') + formatColumnsToGet(name)
			})
			psesetsList[formatColumnsToGet(name)] = data.includes(name) ? true : false;
		})

		setColumns(psesetsList);
		localStorage.setItem('vehicleColumns', JSON.stringify(psesetsList));
	}

	const getCustomPresets = async () => {
		getUserCustomPresets()
			.then(res => {
				const response = res.data.response.custom_presets;
				setCustomPresetsList(response);
			})
			.catch((error) => {
				toastr.error('An unexpected error occurred. Please try again later');
			});
	}

	const saveCustomPresetModal = () => {
		setShowCustomPsesetSaveModal(true);
	}

	const saveCustomPreset = async (name) => {
		if (!name.trim() || !/^[a-zA-Z0-9 ]+$/.test(name)) {
			toastr.error('Enter a valid name')
			return
		}

		toggleLoader(true);
		let fields = [];
		Object.entries(columns).map(([name, checked]) => { if (checked === true) fields.push(formatColumnsToSet(name)) });
		const params = { name: name, fields: fields };

		await saveUserCustomPresets(params)
			.then(() => {
				toastr.success('Custom Preset saved');
			})
			.catch((error) => {
				toggleLoader(false);
				toastr.error('An unexpected error occurred. Please try again later');
			});

		setShowCustomPsesetSaveModal(false);
		getCustomPresets();
		toggleLoader(false);
	}

	const removeCustomPresetModal = (name) => {
		setDeleteCustomPreset(name);
		setShowCustomPsesetDeleteModal(true);
	}

	const removeCustomPreset = async (name) => {
		toggleLoader(true);
		await deleteUserCustomPresets({ name: name });
		setShowPresets(false);
		setShowCustomPsesetDeleteModal(false);
		toastr.success('Custom Preset removed');
		getCustomPresets();
		toggleLoader(false);
	}

	const closeSaveCustomPresetModal = () => {
		setShowCustomPsesetSaveModal(false);
	}

	const closeDeleteCustomPresetModal = () => {
		setShowCustomPsesetDeleteModal(false);
	}

	showCompanies && $(document).mouseup((e) => { if ($(".flexColumns").has(e.target).length === 0) setShowCompanies(false) });
	showPresets && $(document).mouseup((e) => { if ($(".flexColumns").has(e.target).length === 0) setShowPresets(false) });
	const devicesData = devices

	return (
		<div className="manage-vehicles">
			<div className="page-subheader manage-vehicles-subheader">
				<div className="settings-companies">
					{/* Search box */}
					<div className="subheader-section search">
						<SearchBar term={searchText} onSearch={dataSearch} />
					</div>
					<div className="settings">
						{/* Calendar box */}
						<div className="event-date date">
							<DateDropdown
								start_date={startDate}
								end_date={endDate}
								onSelectDate={changeDate}
								maxDate={endOfDay(new Date())}
							/>
						</div>
						{/* Companies dropdown */}
						<div className="flexColumns">
							<CustomButton
								variant="primary"
								onClick={() => setShowCompanies(!showCompanies)}
								prefix="primaryCompany"
							>
								Companies
								<span style={{ paddingLeft: '10px' }}>{showCompanies ? <svg height="12" width="12" viewBox="0 0 24 24" fill="#fff" transform="rotate(180)" xmlns="http://www.w3.org/2000/svg"><path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" /></svg> :
									<svg height="12" width="12" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" /></svg>}
								</span>
							</CustomButton>
							{showCompanies &&
								<div className="companies-select-menu">
									<div className="flexColumns">
										<div className="category-title">Companies</div>
										<SearchBar
											term={searchCompaniesTerm}
											placeholder='Search Companies...'
											onSearch={onSearchCompanies}
										/>
										<div>
											<CustomButton
												variant="primary"
												style={{ marginTop: '10px', marginRight: '10px' }}
												size="icon"
												onClick={onClearAllClick}
											>
												Clear All
											</CustomButton>
											{`(${selectedCompanies.length} selected)`}
										</div>
										<hr />
										{companiesList.map((item) => (
											<div key={item.id}>
												<label>
													<input
														type="checkbox"
														checked={selectedCompanies.includes(item.id)}
														id={item.id}
														name={item.company_name}
														onChange={toggleCheckbox}
													/>
													<span>{item.company_name}</span>
												</label>
											</div>
										))
										}
									</div>
								</div>}
						</div>
					</div>
				</div>
				<div className="settings">
					<Dropdown
						id="vehicle-select-dropdown"
						className="column-select-dropdown"
						role="menuitem"
						drop
					>
						<Dropdown.Toggle as={CustomButtonToggle} prefix="vehicle-select-dropdown" wrapperClassName="text-right" noCaret>
							{columnSelectIcon}
						</Dropdown.Toggle>
						<Dropdown.Menu className="vehicle-select-menu">
							<div className="vehicle-checkbox-group">
								<h5 className="category-title">Columns</h5>
								<div style={{ display: "flex" }}>
									<div className="col-sm-6">
										{Object.entries(columns).slice(0, 7).map(([name, checked]) => (
											<label key={name}>
												<input
													type="checkbox"
													className="vehicle-checkbox"
													checked={checked}
													id={name}
													onChange={toggleCheckbox}
												/>
												{name}
											</label>
										))}
									</div>
									<div className="col-sm-6">
										{Object.entries(columns).slice(7, 14).map(([name, checked]) => (
											<label key={name}>
												<input
													type="checkbox"
													className="vehicle-checkbox"
													checked={checked}
													id={name}
													onChange={toggleCheckbox}
												/>
												{name}
											</label>
										))}
									</div>
								</div>
								<CustomButton
									variant="secondary"
									onClick={saveCustomPresetModal}
									prefix="secondaryBtn"
								>
									Save
								</CustomButton>
							</div>
						</Dropdown.Menu>
					</Dropdown>
					<div className="flexColumns">
						<CustomButton
							variant="primary"
							onClick={() => setShowPresets(!showPresets)}
							prefix="primary"
						>
							Column Presets
							<span style={{ paddingLeft: '10px' }}>{showPresets ? <svg height="12" width="12" viewBox="0 0 24 24" fill="#fff" transform="rotate(180)" xmlns="http://www.w3.org/2000/svg"><path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" /></svg> :
								<svg height="12" width="12" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" /></svg>}
							</span>
						</CustomButton>
						{showPresets &&
							<div className="presets-select-menu">
								<div className="presetsItem">
									{presetsList.map(elm => (
										<div key={elm.name}>
											<a
												name={elm.name}
												onClick={() => toggleChangePresets(elm.fields)}
											>
												{elm.name}
											</a>
										</div>
									))
									}
									<span className="custom-presets">Custom Presets</span>
									{customPresetsList.map(elm => (
										<div className="custom-presets-list" key={elm.name}>
											<a
												name={elm.name}
												onClick={() => toggleChangePresets(elm.fields)}
											>
												{elm.name}
											</a>
											<svg onClick={() => removeCustomPresetModal(elm.name)} version="1.1" fill="red" width="14" height="14"
												xmlns="http://www.w3.org/2000/svg"
												x="0px" y="0px" viewBox="0 0 42 42">
												<path d="M21.002,26.588l10.357,10.604c1.039,1.072,1.715,1.083,2.773,0l2.078-2.128
	c1.018-1.042,1.087-1.726,0-2.839L25.245,21L36.211,9.775c1.027-1.055,1.047-1.767,0-2.84l-2.078-2.127
	c-1.078-1.104-1.744-1.053-2.773,0L21.002,15.412L10.645,4.809c-1.029-1.053-1.695-1.104-2.773,0L5.794,6.936
	c-1.048,1.073-1.029,1.785,0,2.84L16.759,21L5.794,32.225c-1.087,1.113-1.029,1.797,0,2.839l2.077,2.128
	c1.049,1.083,1.725,1.072,2.773,0L21.002,26.588z"/>
											</svg>
										</div>
									))
									}
								</div>
							</div>}
					</div>
				</div>
			</div>

			<main className="main-content-block">
				{hasAccessAddVehicle
					? <AddAssetContainer companiesList={companiesList} changedDevicesList={getDevices} />
					: <div className="add-asset-block" />
				}

				<ManageAssetsContainer
					devices={devicesData}
					initialData={devicesInit}
					companyData={companyData}
					columns={columns}
					selectedDevices={selectedDevices}
					selectDevice={selectDevice}
					filterColumn={filterColumn}
					filterConfigColumn={filterConfigColumn}
					toggleCheckbox={toggleCheckbox}
					highlightData={highlightData}
					selectProfile={props.selectProfile}
					page={page}
					sizePerPage={sizePerPage}
					totalSize={totalSize}
					sortDevicesName={sortDevicesName}
					sortDevicesOrder={sortDevicesOrder}
					handleDevicesSortChange={handleDevicesSortChange}
					handlePageChange={handlePageChange}
					handleSizePerPageChange={handleSizePerPageChange}
					fetchAllDevicesForExport={getAllDevicesForExport}
				/>
			</main>
			{showCustomPsesetSaveModal &&
				<ModalSavePreset
					savePreset={saveCustomPreset}
					closeModal={closeSaveCustomPresetModal}
				/>}
			{showCustomPsesetDeleteModal &&
				<ModalDeletePreset
					deletePreset={() => removeCustomPreset(deleteCustomPreset)}
					name={deleteCustomPreset}
					closeModal={closeDeleteCustomPresetModal}
				/>}
		</div>
	);
}

ManageAssets.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	assets: PropTypes.objectOf(PropTypes.any).isRequired,
	updateLastViewedAssetsList: PropTypes.func.isRequired
}

const mapStateToProps = ({ user, company, assets }) => ({
	user: user.user,
	selectedCompanies: user.selectedCompanies,
	company: company.company,
	assets,
})

const mapDispatchToProps = dispatch => ({
	updateLastViewedAssetsList: (state) => {
		dispatch({ type: 'SET_LAST_VIEWED_ASSETS', payload: state })
	},
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show })
	},
	setSelectedCompanies: (state) => {
		dispatch({ type: 'SET_SELECTED_COMPANIES', payload: state })
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageAssets)
